import type { User } from 'src/api/organization';

import type { ProjectDTO } from './project.dto';
import type { ActivityDTO } from './activity.dto';
import type { SiteDTO } from './site.dto';

export enum TaskStatus {
  OPEN = 'open',
  CLOSED = 'closed',
}

export enum TaskPriority {
  LOW = 'low',
  NORMAL = 'normal',
  HIGH = 'high',
  URGENT = 'urgent',
}

export type AutomationType = 'pre_request' | 'request' | null;

export interface TaskDTO {
  id: number;
  title: string;
  description: string;
  status: TaskStatus;
  dueDate: Date | string;
  followUpDate: Date | string;
  project: ProjectDTO;
  activity: ActivityDTO;
  site?: SiteDTO;
  automationType?: AutomationType;
  automationStatus?: string | null;
  createdBySource?: 'automation' | string | null;
  assignedTo: User;
  creator: User;
  priority: TaskPriority;
  createdAt: Date;
}
